import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MediaPresignApiService } from '../services';
import { ImageModel, EntityTypeId, BundleType, FieldName, ProviderType, FileModel } from '../models';
import { DomSanitizer } from '@angular/platform-browser';


@Pipe({
    name: 'preSignedUrl',
    standalone: false
})
export class PreSignedUrlPipe implements PipeTransform {

  constructor(private readonly mediaPresignApiService: MediaPresignApiService, public sanitizer: DomSanitizer) {
  }

  public transform(
    image: Partial<ImageModel> | null,
    entityType = EntityTypeId.MEDIA,
    bundle = BundleType.IMAGE,
    fieldName = FieldName.AWS_FILE): Observable<string> {

    if (!image) {
      return of('');
    }

    if (this.isFile(image)) {
      const url = window.URL.createObjectURL(image.file);
      return of(url);
    }

    if (image.isOffline && image.filePath) {
      return of(this.sanitizer.sanitize(
        SecurityContext.RESOURCE_URL,
        this.sanitizer.bypassSecurityTrustResourceUrl(image.uri || image.url)
      ));
    }

    if (typeof (image) === 'string') {
      return of(image);
    }

    const isAws = image.provider === ProviderType.AWS && image.key;

    if (isAws) {
      return this.mediaPresignApiService.getPreSignedUrl(entityType, bundle, fieldName, image, image.preSignedToken);
    }

    return of(image.uri || image.url || '');
  }

  protected isFile(video: Partial<FileModel> | { file: File }): video is { file: File } {
    return 'file' in video && video?.file instanceof File;
  }
}
